import LocalPrintshopIcon from '@mui/icons-material/LocalPrintshop';
import {
  Box,
  Button,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  IconButton,
  Stack,
  Tooltip,
  Typography
} from '@mui/material';
import moment from 'moment';
import { useEffect, useRef, useState } from 'react';
import Loader from 'src/components/common/Loader';
import { PopupComponent } from 'src/components/common/PopupComponent';
import { usePermissionWrapper } from 'src/components/hooks/usePermissionWrapper';
import { hideLoader, showLoader } from 'src/store/Loader';
import { setMessage } from 'src/store/Message';
import { setFormLibraryDataIsOpen } from 'src/store/SelectedIntrialPatient';
import { setConfirmExitValue } from 'src/store/confirmExitValue';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { usePreferedDateFormat } from 'src/util/DateFormatter';
import staticData from '../../../resources/static.json';
import DJ2Form from '../ToolkitForms/configurableformprovider';
import { useToolKitForms } from './useToolkitForms';
import ESignConsentReAuth from 'src/components/common/ESignConsentReAuth';
import { useValidUserForReAuth } from 'src/components/hooks/useValidUserForReAuth';

export default function FormLibraryData({ patinetDetails, setisFieldChanged, isFieldChanged }: any) {
  const { isValidUserForReAuth } = useValidUserForReAuth();
  const dispatch = useAppDispatch();
  const { checkPermission } = usePermissionWrapper();
  const savePermission = checkPermission('manage_patient_trail_notebook');
  const signPermission = checkPermission('sign_toolkit_forms');
  const selectedStudy: any = useAppSelector(state => state.site.selectedStudy);
  const selectedCountry = useAppSelector(state => state.site.selectedCountry);
  const selectedSite = useAppSelector(state => state.site.selectedSite);
  const user = useAppSelector(state => `${state.user.user?.firstName} ${state.user.user?.lastName}`);
  const formLibraryMainData = useAppSelector(state => state.SelectedIntrialPatientInfo.formLibraryMainData);
  const currentPatientTrailTab = useAppSelector(state => state.SelectedIntrialPatientInfo.currentPatientTrailTab);
  const { getPreferredDateTimeInLocal, preferedDateFormat } = usePreferedDateFormat();
  const [openSignPopup, setOpenSignPopup] = useState(false);
  const [openSignConsent, setOpenSignConsent] = useState(false);
  const rowData = staticData.PatientTrialNoteBookData.rowData;
  const {
    OID,
    published_version: publishedVersion,
    name,
    id,
    signed_by: signedByVal,
    signed_on: signedOnVal,
    e_sign_form: eSignForm,
    signed_reason: signedReasonVal
  } = formLibraryMainData;
  const formRef: any = useRef(null);
  const [defaultValues, setDefaultValues] = useState(null as any);
  const [rules, setRules] = useState<any>(null as any);
  const tempField = 1;
  if (Object.keys(patinetDetails).length === 0) {
    dispatch(setFormLibraryDataIsOpen(false));
  }

  const {
    createToolkitFromDataFunc,
    createToolkitFromDataIsError,
    createToolkitFromDataIsSuccess,
    createToolkitFromDataIsLoading,
    createToolkitFromDataError,
    selectToolkitFromDataFunc,
    selectToolkitFromData,
    selectToolkitFromDataIsError,
    selectToolkitFromDataIsSuccess,
    selectToolkitFromDataIsLoading,
    getFormLibrary,
    getFormLoading,
    formData,
    updateToolkitormDataFunc,
    updateToolkitormDataIsSuccess,
    updateToolkitormDataIsError,
    updateToolkitormDataIsLoading,
    updateToolkitormDataError,
    signToolkitformFunc,
    signToolkitformData,
    signToolkitformIsSuccess,
    signToolkitformIsLoading,
    getPatientToolkitFormByIdFunc,
    patientToolkitFormByIdData,
    patientToolkitFormByIdIsSuccess
  } = useToolKitForms();

  useEffect(() => {
    if (
      updateToolkitormDataIsLoading ||
      selectToolkitFromDataIsLoading ||
      createToolkitFromDataIsLoading ||
      getFormLoading ||
      signToolkitformIsLoading
    ) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }
  }, [
    updateToolkitormDataIsLoading,
    selectToolkitFromDataIsLoading,
    createToolkitFromDataIsLoading,
    getFormLoading,
    signToolkitformIsLoading
  ]);

  const [changedData, setchangedData] = useState<any>({});
  const [isUpdate, setIsUpdate] = useState<any>(false);
  const [currentDataEntryFormId, setcurrentDataEntryFormId] = useState<any>(null);
  const [signedBy, setSignedBy] = useState<any>('');
  const [signedOn, setSignedOn] = useState<any>('');
  const [signedReason, setSignedReason] = useState<any>('');

  const onDJ2Change = (data: any, fieldConfig: any) => {
    if (fieldConfig.error) {
      for (const section of formJsonData.sections) {
        for (const row of section.rows) {
          for (const field of row.fields) {
            if (fieldConfig.key === field.key) {
              field.helperText = '';
              field.error = false;
              break;
            }
          }
        }
      }
    }
    setConfirmExitValue(dispatch, true);
    setisFieldChanged(true);
    setDefaultValues({ ...defaultValues, ...data });
  };
  const handleCheckEmptyValues = () => {
    const data: any = JSON.parse(JSON.stringify(changedData));
    delete data?.type;
    delete data?.section_attchements;
    delete data?.file_data;
    delete data?.removedFiles;
    delete data?.event_uuid;
    delete data?.file_data;
    Object.keys(data).map((dataKey: any) => {
      if (data[dataKey] == null) {
        delete data[dataKey];
      }
      if (Array.isArray(data[dataKey])) {
        data[dataKey] = { key: data[dataKey] };
      }
    });
    return Object.keys(data).length;
  };
  const updateFormConfig = (data: any) => {
    formJsonData?.sections.map((section: any) => {
      section?.rows.map((row: any) => {
        row?.fields.map((field: any) => {
          if (data.errors && field.key && data.records && data.records[field.key]) {
            field.helperText = data.records[field.key]?.message;
            field.error = true;
          } else {
            field.helperText = '';
            field.error = false;
          }
        });
      });
    });
  };
  const checkType = (obj: any) => {
    for (const keys of Object.keys(obj)) {
      if (obj?.[keys]?.type === 'required') {
        return true;
      }
    }
    return false;
  };
  const onFormSubmit = async (data: any) => {
    if (!isFieldChanged) {
      dispatch(
        setMessage({
          msgDetails: 'No data modified',
          severity: 'info'
        })
      );
      return;
    }
    updateFormConfig(data);
    let validation = false;
    if (Object.keys(rules).length > 0) {
      Object.keys(rules).map((key: any) => {
        if (rules[key]?.required?.value) {
          if (changedData[key] == null || changedData[key] == '') {
            validation = true;
          }
        }
      });
    }
    if (data.errors && checkType(data.records)) {
      dispatch(
        setMessage({
          msgDetails: 'Missing mandatory data',
          severity: 'error'
        })
      );
    } else if (data.errors) {
      dispatch(
        setMessage({
          msgDetails: 'Invalid Data',
          severity: 'error'
        })
      );
    }
    if (data.success && !validation) {
      delete changedData?.type;
      const dataObj: any = JSON.parse(JSON.stringify(changedData));

      /**section docs maping submitted files start */
      const sectionAttchements = dataObj?.section_attchements;
      const prevFilesData = dataObj?.file_data;
      const removedFiles: any = dataObj?.removedFiles ? dataObj?.removedFiles : [];
      delete dataObj?.section_attchements;
      delete dataObj?.file_data;
      delete dataObj?.removedFiles;
      delete dataObj?.event_uuid;

      const fileData: any = [];
      if (prevFilesData) {
        prevFilesData.map((file: any) => {
          if (!removedFiles.includes(file.file_master_id)) {
            fileData.push({
              file_id: file.file_master_id,
              ctms_raw_file_name: file.ctms_raw_file_name,
              section_name: file.section_name,
              section_number: file.section_number
            });
          }
        });
      }
      if (sectionAttchements) {
        sectionAttchements.map((section: any) => {
          if (section?.submitedFiles) {
            section?.submitedFiles.map((file: any) => {
              if (!removedFiles.includes(file.id)) {
                fileData.push({
                  file_id: file.id,
                  ctms_raw_file_name: file.ctms_raw_file_name,
                  section_name: section.sectionData.section_name,
                  section_number: section.sectionData.sectionId
                });
              }
            });
          }
        });
      }
      /**section docs maping submitted files end */

      if (Object.keys(dataObj).length > 0) {
        Object.keys(dataObj).map((dataKey: any) => {
          if (dataObj[dataKey] == null) {
            delete dataObj[dataKey];
          }
          if (Array.isArray(dataObj[dataKey])) {
            dataObj[dataKey] = { key: dataObj[dataKey] };
          }
        });
      }
      delete dataObj?.file_data;
      const reqPayload = {
        OID,
        patient_id: patinetDetails?.patient_identifier,
        toolkit_form_version: publishedVersion,
        data_json: dataObj,
        file_data: fileData
      };
      if (isUpdate && currentDataEntryFormId != null) {
        updateToolkitormDataFunc({
          data: { ...reqPayload, id: currentDataEntryFormId, updated_by: user },
          study_id: selectedStudy,
          site_id: selectedSite,
          country: selectedCountry
        });
      } else {
        createToolkitFromDataFunc({
          data: { ...reqPayload, created_by: user },
          study_id: selectedStudy,
          site_id: selectedSite,
          country: selectedCountry
        });
      }
    }
    setisFieldChanged(false);
  };

  const handleSave = () => {
    formRef.current.submit(onFormSubmit);
    setConfirmExitValue(dispatch, false);
  };

  const handleSignConfirm = async () => {
    setOpenSignConsent(true);
    setOpenSignPopup(false);
  };

  const handleOpenSignPopup = () => {
    if (currentDataEntryFormId == null || isFieldChanged) {
      dispatch(
        setMessage({
          msgDetails: 'Please Save the Form',
          severity: 'error'
        })
      );
      setOpenSignPopup(false);
    } else {
      setOpenSignPopup(true);
    }
  };
  const handleClose = () => setOpenSignPopup(false);

  useEffect(() => {
    if (formLibraryMainData) {
      getFormLibrary({
        OID,
        published_version: publishedVersion,
        study_id: selectedStudy,
        country: selectedCountry,
        site_id: selectedSite,
        // application: process.env.REACT_APP_NAME,
        // application_section: process.env.REACT_APP_NAME,
        application: process.env.REACT_APP_NAME_TEMP,
        application_section: process.env.REACT_APP_NAME_TEMP,
        application_module_section: 'PATIENT TRIAL NOTEBOOK'
      });
    }
  }, [formLibraryMainData]);

  const [formJsonData, setFormJsonData] = useState<any>(null);

  const getAndShowToolkitFormData = async () => {
    const reqPayload = {
      OID,
      patient_id: patinetDetails?.patient_identifier,
      toolkit_form_version: publishedVersion
    };
    await selectToolkitFromDataFunc({
      data: reqPayload,
      study_id: selectedStudy,
      site_id: selectedSite,
      country: selectedCountry
    });
  };

  useEffect(() => {
    if (formData) {
      getAndShowToolkitFormData();
    }
  }, [formData]);

  const bindDefaultValuesToForm = (clonedObj: any) => {
    const reClonedObj = JSON.parse(JSON.stringify(clonedObj));
    reClonedObj.sections.map((section: any) => {
      section.rows.map((row: any) => {
        row.fields.map((field: any) => {
          field.isCustomForm = true;
          if (field.cmp == 'checkbox' && field?.default_value && field?.default_value.length > 0) {
            let values = {};
            field?.default_value.map((val: any) => {
              values = { ...values, [val]: true };
            });
            // field.default_value = values;
          } else if (
            field?.cmp == 'select' &&
            field?.default_value &&
            field?.data_dictionary_values &&
            field?.data_dictionary_values.length > 0
          ) {
            if (field?.multiple) {
              const values = [];
              for (let i = 0; i < field?.data_dictionary_values.length; i++) {
                if (field?.default_value.includes(field?.data_dictionary_values[i].value)) {
                  values.push({
                    label: field?.data_dictionary_values[i].code_list_value,
                    value: field?.data_dictionary_values[i].value
                  });
                }
              }
              field.default_value = values;
            } else {
              let values = {};
              for (let i = 0; i < field?.data_dictionary_values.length; i++) {
                if (field?.data_dictionary_values[i].value == field?.default_value) {
                  values = {
                    label: field?.data_dictionary_values[i].code_list_value,
                    value: field?.data_dictionary_values[i].value
                  };
                  break;
                }
              }
              field.default_value = values;
            }
          }
        });
      });
    });
    setFormJsonData(reClonedObj);
  };

  useEffect(() => {
    if (selectToolkitFromData && selectToolkitFromDataIsSuccess && formData) {
      const clonedObj: any = JSON.parse(JSON.stringify(formData?.meta));
      if (selectToolkitFromData?.result.length > 0) {
        let savedData: any = {};
        clonedObj.sections.map((section: any) => {
          section.rows.map((row: any) => {
            row.fields.map((field: any) => {
              const values = selectToolkitFromData?.result[0][field?.key];
              if (field.cmp == 'checkbox' && values && Object.keys(values).length > 0) {
                const valArr: any = [];
                Object.keys(values).map((valkey: any) => {
                  valArr.push(valkey);
                });
                field.default_value = valArr;
                savedData = { ...savedData, [field?.key]: values };
              } else if (field.cmp == 'select' && values && Object.keys(values).length > 0) {
                if (field?.multiple) {
                  const multiselectVal = values?.key;
                  const valArr: any = [];
                  multiselectVal.map((valkey: any) => {
                    valArr.push(valkey?.code_list_value_code || valkey?.value);
                  });
                  field.default_value = valArr;
                  savedData = { ...savedData, [field?.key]: multiselectVal };
                } else {
                  field.default_value = values;
                  savedData = { ...savedData, [field?.key]: values };
                }
              } else {
                field.default_value = selectToolkitFromData?.result[0][field?.key];
                savedData = { ...savedData, [field?.key]: selectToolkitFromData?.result[0][field?.key] };
              }

              setcurrentDataEntryFormId(selectToolkitFromData?.result[0]?.id);
            });
          });
        });
        setchangedData({ ...savedData });
        setFormJsonData(clonedObj);
        setIsUpdate(true);
      } else {
        bindDefaultValuesToForm(clonedObj);
      }
    }
  }, [selectToolkitFromData, selectToolkitFromDataIsSuccess]);

  useEffect(() => {
    if (selectToolkitFromDataIsError && !selectToolkitFromDataIsLoading && formData) {
      bindDefaultValuesToForm(formData?.meta);
    }
  }, [selectToolkitFromDataIsError, selectToolkitFromDataIsLoading]);

  useEffect(() => {
    if (formJsonData?.sections) {
      const formData = formJsonData.sections.flatMap((section: any) => section.rows.flatMap((row: any) => row.fields));
      const initValues = formData.reduce(
        (acc: any, cur: any) => ({ ...acc, [cur.key]: cur.default_value || null }),
        {}
      );
      if (selectToolkitFromData?.result[0]?.file_data) {
        setDefaultValues({
          ...initValues,
          file_data: selectToolkitFromData?.result[0].file_data,
          event_uuid: selectToolkitFromData?.result[0].event_uuid
        });
      } else {
        setDefaultValues({ ...initValues, file_data: [], event_uuid: null });
      }

      let mockRulesObj: any = {};
      formData.map((item: any) => {
        if (item?.required) {
          const makeObj = {
            required: {
              value: true,
              errorText: 'Required'
            }
          };
          mockRulesObj = { ...mockRulesObj, [item.key]: makeObj };
        }
        if (item?.cmp == 'date' && !item.allow_partial) {
          mockRulesObj = {
            ...mockRulesObj,
            [item.key]: { ...mockRulesObj?.[item.key], date: { value: true, errorText: 'Invalid Data' } }
          };
        }
      });
      setRules(mockRulesObj);
    }
  }, [formJsonData, selectToolkitFromData]);

  useEffect(() => {
    if (
      (!createToolkitFromDataIsLoading && createToolkitFromDataIsError) ||
      (!updateToolkitormDataIsLoading && updateToolkitormDataIsError)
    ) {
      const errorData: any = createToolkitFromDataError || updateToolkitormDataError;
      if (errorData?.status == 500 || errorData?.status == 502 || errorData?.status == 503) {
        dispatch(
          setMessage({
            msgDetails: `${errorData?.status} : Internal Server Error`,
            severity: 'error'
          })
        );
      } else if (errorData?.status == 403) {
        dispatch(
          setMessage({
            msgDetails: `${errorData?.status} : Forbbiden Access`,
            severity: 'error'
          })
        );
      } else if (errorData?.status == 404) {
        dispatch(
          setMessage({
            msgDetails: errorData?.data?.context.message,
            severity: 'error'
          })
        );
      }
    }
    if (
      (!createToolkitFromDataIsLoading && createToolkitFromDataIsSuccess) ||
      (!updateToolkitormDataIsLoading && updateToolkitormDataIsSuccess)
    ) {
      dispatch(
        setMessage({
          msgDetails: 'Form updated successfully',
          severity: 'success'
        })
      );
      getAndShowToolkitFormData();
    }
  }, [
    createToolkitFromDataIsLoading,
    createToolkitFromDataError,
    createToolkitFromDataIsError,
    createToolkitFromDataIsSuccess,
    updateToolkitormDataIsSuccess,
    updateToolkitormDataIsError,
    updateToolkitormDataError
  ]);

  useEffect(() => {
    if (signToolkitformData && signToolkitformIsSuccess) {
      setSignedBy(signToolkitformData?.signed_by);
      setSignedOn(signToolkitformData?.signed_on);
      setSignedReason(signToolkitformData?.signed_reason);
    }
    if (patientToolkitFormByIdData && patientToolkitFormByIdIsSuccess) {
      setSignedBy(patientToolkitFormByIdData?.signed_by);
      setSignedOn(patientToolkitFormByIdData?.signed_on);
      setSignedReason(patientToolkitFormByIdData?.signed_reason);
    }
  }, [signToolkitformData, patientToolkitFormByIdData]);
  useEffect(() => {
    if (currentPatientTrailTab == '1') {
      getPatientToolkitFormByIdFunc({
        parent_id: patinetDetails?.patient_identifier,
        site_id: selectedSite,
        study_id: selectedStudy,
        country: selectedCountry,
        toolkit_form_id: id
      });
    }
    setisFieldChanged(false);
  }, []);
  const handleRowPISign = async (data: any = {}) => {
    if (data.success) {
      if (!isValidUserForReAuth(data.records.user_name)) {
        dispatch(setMessage({ msgDetails: `Please e-sign with the logged in username`, severity: 'error' }));
      } else {
        setOpenSignConsent(false);
        dispatch(showLoader());

        const signPayload = {
          toolkit_form_id: id,
          signed_on: moment().format()
        };
        const signResponse: any = await signToolkitformFunc({
          study_id: selectedStudy,
          parent_id: patinetDetails?.patient_identifier,
          country: selectedCountry,
          site_id: selectedSite,
          data: signPayload,
          username: data.records.user_name,
          password: data.records.password,
          signed_reason: data.records.sign_reason
        });
        if (signResponse?.error) {
          dispatch(setMessage({ msgDetails: `Authorization for ${data.records.user_name} failed`, severity: 'error' }));
        } else {
          dispatch(
            setMessage({
              msgDetails: 'Form is signed successfully',
              severity: 'success'
            })
          );
          setSignedBy(signToolkitformData.signed_by);
          setSignedOn(signToolkitformData.signed_on);
          setSignedReason(signToolkitformData.signed_reason);
        }
        dispatch(hideLoader());
      }
    }
  };
  return (
    <>
      <Grid container spacing={2} sx={{ mb: 1.5, alignItems: 'center' }}>
        <Grid item>
          <Typography variant="h5" component="h5" sx={{ margin: 0, fontSize: '20px', fontWeight: 500 }}>
            {name}
          </Typography>
        </Grid>
        <Grid item xs sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end' }}>
          <Stack direction="row" spacing={1.5}>
            {signedByVal || signedBy ? (
              <span className="signedInfo">
                Signed by <strong>{signedByVal ? signedByVal : signedBy}</strong> on{' '}
                <span color="text.secondary">
                  {signedOnVal ? getPreferredDateTimeInLocal(signedOnVal) : getPreferredDateTimeInLocal(signedOn)}
                </span>
                <br />
                <span className="signReasonrow">
                  <span color="text.secondary">Reason:</span> &ldquo;{signedReasonVal ? signedReasonVal : signedReason}
                  &rdquo;
                </span>
              </span>
            ) : signPermission && currentPatientTrailTab === '2' && eSignForm ? (
              <Button variant="contained" onClick={handleOpenSignPopup} disabled={!currentDataEntryFormId}>
                Sign
              </Button>
            ) : null}
            <Button variant="contained" sx={{ alignSelf: 'center', whiteSpace: 'nowrap' }} disabled={!savePermission}>
              Publish to ISF
            </Button>
            <Tooltip title={!handleCheckEmptyValues() ? `please enter data to proceed further` : null} placement="top">
              <span>
                <Button
                  sx={{ alignSelf: 'center' }}
                  onClick={handleSave}
                  disabled={
                    !savePermission ||
                    currentPatientTrailTab == '1' ||
                    !isFieldChanged ||
                    signedByVal ||
                    signedBy ||
                    !handleCheckEmptyValues()
                  }
                >
                  Save
                </Button>
              </span>
            </Tooltip>
            <IconButton aria-label="Print" color="primary" sx={{ alignSelf: 'center' }} disabled={!savePermission}>
              <LocalPrintshopIcon />
            </IconButton>
          </Stack>
        </Grid>
      </Grid>
      <>
        <Box className="SummaryDetails_wrap">
          <Typography variant="h5" component="h5" sx={{ mb: 2 }}>
            Subject Summary
          </Typography>
          <Grid container spacing={2} rowSpacing={1}>
            {rowData.map((ele: any, index: number) => (
              <Grid item md={4} key={index}>
                <Typography variant="h6" component="h6">
                  {ele.textValue}:&nbsp;{' '}
                  <span className="results">
                    {ele.type === 'date'
                      ? preferedDateFormat(patinetDetails?.[ele.value])
                      : patinetDetails?.[ele.value]}
                  </span>
                </Typography>
              </Grid>
            ))}
          </Grid>
        </Box>
        {formJsonData != null ? (
          defaultValues && rules ? (
            <DJ2Form
              updateFormConfig={updateFormConfig}
              key={tempField}
              ref={formRef}
              initialValues={defaultValues}
              rules={rules}
              formConfig={formJsonData}
              onChange={onDJ2Change}
              SetchangedData={setchangedData}
              isReadOnly={currentPatientTrailTab == '1' || signedByVal || signedBy || formLibraryMainData?.completion}
            />
          ) : null
        ) : null}
      </>
      <PopupComponent open={openSignPopup} onClose={handleClose}>
        <Loader />
        <DialogTitle>Personal Signature</DialogTitle>
        <DialogContent className="tsda_prescreenDialog">
          <DialogContentText>
            {/* <Alert severity="info">Confirm the forms to be sent to Prescreen ID by listing the selected forms </Alert> */}
            <Typography sx={{ color: 'rgba(0,0,0,0.87)' }}>
              My signature confirms that I accept the form and that all data has been entered correctly.
            </Typography>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} className="grey-btn">
            Cancel
          </Button>
          <Button onClick={handleSignConfirm}>Confirm</Button>
        </DialogActions>
      </PopupComponent>
      {openSignConsent && (
        <ESignConsentReAuth
          openSignConsent={openSignConsent}
          setOpenSignConsent={setOpenSignConsent}
          handleConfirmSign={handleRowPISign}
        />
      )}
    </>
  );
}
